<template>
  <div class="modelling-settings">
    скоро...
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss"></style>

<i18n>
{
  "ru": {
  },
  "en": {
  }
}
</i18n>
